import { useTransactionLogStorage } from "@/hooks/Storage/useTransactionLogStorage";
import { useAccount } from "@/hooks/useAccount";
import clsx from "clsx";
import Link from "next/link";
import { HiCheck, HiOutlineArrowUp } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import ArrowRightSvg from "../Svg/ArrowRightSvg";
import { AiOutlineExport } from "react-icons/ai";

export const TransactionHistory = () => {
  const { transactionLogs } = useTransactionLogStorage();
  const { chain } = useAccount();

  return (
    <div className="w-full">
      <h1 className="text-bitzy-gray font-bold mb-4">Recent Transactions</h1>
      {transactionLogs.length === 0 && (
        <div className="w-full flex justify-center items-center">
          <h2 className="text-bitzy-white">No transactions yet</h2>
        </div>
      )}
      <div className="w-full h-fit max-h-[195px] flex flex-col gap-1 overflow-y-auto">
        {transactionLogs.map((log, index) => {
          return (
            <div
              key={index}
              className="w-full grid grid-cols-[16px_auto_16px] gap-2"
            >
              <div className="relative flex items-center justify-center w-4 h-4 mt-1">
                {log?.status === "submitted" && (
                  <HiOutlineArrowUp
                    className={clsx("ease-in-out text-bitzy-theme")}
                    size={12}
                  />
                )}
                {log?.status === "confirmed" && (
                  <HiCheck
                    className={clsx("ease-in-out text-bitzy-green")}
                    size={12}
                  />
                )}
                {log?.status === "cancelled" && (
                  <IoClose
                    className={clsx("ease-in-out text-bitzy-red")}
                    size={12}
                  />
                )}
                <div className="absolute transform translate-x-1/2 translate-y-1/2 right-1/2 bottom-1/2">
                  <div
                    className={clsx(
                      "w-4 h-4 border border-solid rounded-full",
                      ["pending", "submitted"].includes(log?.status ?? "") &&
                        "border-t-transparent animate-[spin_2s_linear_infinite]",
                      clsx(
                        log?.status === "cancelled" && "border-bitzy-red",
                        log?.status === "confirmed" && "border-bitzy-green",
                        log?.status === "submitted" && "border-bitzy-theme"
                      )
                    )}
                  ></div>
                </div>
              </div>
              <h2 className="text-bitzy-white text-sm md:text-base">
                {log.description || log.title || "N/A"}
              </h2>
              {log.hash && (
                <Link
                  href={`${chain?.blockExplorers?.default?.url}/tx/${log.hash}`}
                  target="_blank"
                  className="flex justify-end ms-auto w-fit mt-1 gap-1 text-xs font-medium text-bitzy-white hover:underline"
                >
                  <AiOutlineExport className="w-4 h-4" />
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
